import * as types from '../constants/ActionTypes';

export const cnbsInitialState = {
  paymentStatusOptions: [
    { value: 'open', label: 'Open', clearableValue: false },
    { value: 'paid', label: 'Cleared', clearableValue: false }
  ],
  currencyOptions: [
    { value: 'USD', label: 'USD', clearableValue: false },
    { value: 'Euro', label: 'Euro', clearableValue: false }
  ],
  dueOptions: [
    { value: 'Due', label: 'Due up to', clearableValue: false },
    { value: 'All', label: 'Show All', clearableValue: false }
  ],
  invoiceStatusOptions: [
    { value: '03', label: 'All' },
    { value: '01', label: 'Due' },
    { value: '02', label: 'Complete' },
  ],
  invoicePaymentOptions: [
    { value: '009', label: 'Due' },
    { value: '010', label: 'Not due' },
    { value: '011', label: 'Due or not due' }
  ],
  periodOptions: [
    { value: '0', label: 'Today' },
    { value: '1', label: 'Since yesterday' },
    { value: '7', label: 'Last 7 days' },
    { value: '30', label: 'Last 30 days' },
    { value: '365', label: 'Last 365 days' },
    { value: '-1', label: 'Custom date range' }
  ],
  characteristicsOptions: [
    { value: '01', label: 'Invoice Number' },
  ],
  invoices: [],
  currentUser: null,
  listHeight: '400px',
  animating: 0,
  invoiceListRequest: '',
  selectedCurrencyOptionValue: '',
  payerDetails: {
    payment_cards: []
  },
  paymentStatuses: null,
  reasonNotRequired: '',
  cvvRequired: false,
  cvvValue: '',
  selectedCard: '',
  overPayNote: '',
  accountTypes: [],
  primaryAccountTypes: [],
};

export default function reducer(state = cnbsInitialState, action) {
  switch (action.type) {
    // Common props

    case types.LOADING_INCREMENT: {
      return { ...state, animating: state.animating + 1 };
    }
    case types.LOADING_DECREMENT: {
      return { ...state, animating: state.animating - 1 };
    }
    
    case types.GET_USER_SUCCESS: {
      return {
        ...state,
        currentUser: action.payload,
      };
    }

    case types.GET_INVOICES_SUCCESS: {
      return {
        ...state,
        invoices: action.payload
      };
    }

    case types.UPDATE_INVOICE_LIST_REQUEST: {
      return { ...state, invoiceListRequest: action.payload };
    }

    case types.UPDATE_CURRENCY_CODE: {
      return { ...state, selectedCurrencyOptionValue: action.payload };
    }
    case types.UPDATE_CURRENCY_OPTIONS: {
      return { ...state, currencyOptions: action.payload };
    }
    
    case types.GET_PAYER_DETAILS_SUCCESS: {
      return {
        ...state,
        payerDetails: action.payload
      };
    }

    case types.UPDATE_PAYMENT_CARD_OPTIONS: {
      return { ...state, paymentCardOptions: action.payload };
    }

    case types.POST_PAYMENT_REQUEST: {
      return {
        ...state,
        showPaymentStatus: true
      };
    }

    case types.POST_PAYMENT_SUCCESS: {
      return {
        ...state,
        showPaymentStatus: true,
        paymentStatuses: action.payload
      };
    }

    case types.GET_INVOICE_CURRENCY_SUCCESS: {
      return {
        ...state,
        currencyOptions: action.payload
      };
    }

    case types.UPDATE_PAYMENT_STATUS: {
      return { ...state, paymentStatuses: null, showPaymentStatus: false };
    }

    case types.UPDATE_CVV_CONTROL_FLAG: {
      return { ...state, cvvRequired: action.payload };
    }

    case types.UPDATE_CVV:
      return { ...state, cvvValue: action.payload };

    case types.UPDATE_SELECTED_CARD:
      return { ...state, selectedCard: action.payload };

    case types.OVER_PAY_NOTE:
      return { ...state, overPayNote: action.payload };

    case types.UPDATE_ACCOUNT_TYPES: {
      return {
        ...state, accountTypes: action.payload,
      };
      }

    case types.UPDATE_PRIMARY_ACCOUNT_TYPES: {
      return {
        ...state, primaryAccountTypes: action.payload,
      };
      }

    default: {
      return state;
    }
  }
}
